import { Button, Form, Space } from 'antd';
import { VerzendBevestiging } from './components/verzendBevestiging';
import { RapportageType } from '@/lib/types';
import { Roles, useUserContext } from '@/lib/context';
import { useEffect } from 'react';

export const Step5: React.FunctionComponent<{ onSubmit: (rapportageType: RapportageType) => void; isSaving: boolean }> = ({ onSubmit, isSaving }) => {
  const form = Form.useFormInstance();
  const isDeelRapportage = form.getFieldValue('isDeelRapportage');

  const handleFullReportSubmit = () => onSubmit(RapportageType.VolledigeRapportage);
  const handlePartialReportSubmit = () => onSubmit(RapportageType.DeelRapportage);

  const { username, roles } = useUserContext();

  useEffect(() => {
    if (roles.some(r => r === Roles.KeyuserBevoegdgezag)) {
      form.setFieldValue(['verzendBevestiging', 'keyUsername'], username);
    }
  }, [roles, username, form]);

  return (
    <>
      <VerzendBevestiging />
      <Space>
        {!isDeelRapportage ? (
          <Button loading={isSaving} disabled={isSaving} onClick={handleFullReportSubmit} type="primary" >
            Versturen als volledige rapportage
          </Button>
        ) : (
          <Button loading={isSaving} disabled={isSaving} onClick={handlePartialReportSubmit} type="primary" >
            Versturen als deelrapportage
          </Button>
        )}
      </Space>
    </>
  );
};